import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { galleryImages } from '../data/gallery';

const GalleryImage: React.FC<{ url: string; alt: string }> = ({ url, alt }) => (
  <div 
    className="relative aspect-square group overflow-hidden rounded-xl transition-all duration-300 hover:z-10 hover:scale-105 hover:shadow-xl"
  >
    <img
      src={url}
      alt={alt}
      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
      loading="lazy"
    />
  </div>
);

const GallerySection: React.FC = () => {
  return (
    <section id="connect" className="py-20 bg-gray-50 dark:bg-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 dark:text-gray-100 mb-4 font-['Instrument_Serif']">
            Connect with Us
          </h2>
          <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
          <p className="text-gray-700 dark:text-gray-300 text-xl md:text-2xl max-w-2xl mx-auto font-['Instrument_Serif']">
            Explore the products, services and transformations that keep our clients coming back.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {galleryImages.map((image) => (
            <GalleryImage
              key={image.id}
              url={image.url}
              alt={image.alt}
            />
          ))}
        </div>
        
        <div className="flex flex-col md:flex-row justify-center gap-4 mt-12 w-full max-w-md mx-auto">
          <a
            href="https://www.instagram.com/3dbarbers/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-900 dark:bg-white dark:text-gray-900 text-white hover:bg-amber-500 hover:text-white dark:hover:bg-amber-500 dark:hover:text-white px-6 py-3 rounded-full transition-all duration-300 flex items-center gap-2 hover:scale-105 w-full md:w-auto justify-center group"
          >
            <Instagram className="w-5 h-5 group-hover:text-white" />
            <span>Instagram</span>
          </a>
          <a
            href="https://www.facebook.com/3DSALONW12"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-900 dark:bg-white dark:text-gray-900 text-white hover:bg-amber-500 hover:text-white dark:hover:bg-amber-500 dark:hover:text-white px-6 py-3 rounded-full transition-all duration-300 flex items-center gap-2 hover:scale-105 w-full md:w-auto justify-center group"
          >
            <Facebook className="w-5 h-5 group-hover:text-white" />
            <span>Facebook</span>
          </a>
          <a
            href="https://www.tiktok.com/@3dsalon"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-900 dark:bg-white dark:text-gray-900 text-white hover:bg-amber-500 hover:text-white dark:hover:bg-amber-500 dark:hover:text-white px-6 py-3 rounded-full transition-all duration-300 flex items-center gap-2 hover:scale-105 w-full md:w-auto justify-center group"
          >
            <svg className="w-5 h-5 group-hover:text-white" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
            </svg>
            <span>TikTok</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;